import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  documents = [
    {
      "_id": "65a7d716293d397b20a01d39",
      "name": "Driver License",
      "status": "active",
      "key": "driverLicenceImageUrl",
      "type": "driver"
    },
    {
      "_id": "65a8e764bd711937c9b16496",
      "name": "Vehicle Fintess Certificate",
      "status": "active",
      "key": "vehicleFitnessCertificateImageUrl",
      "type": "vehicle"
    },
    {
      "_id": "65a8f6666511cb64f72aad02",
      "name": "Driver Medical Certificate",
      "status": "active",
      "key": "driverLicenceImageUrl",
      "type": "driver"
    }
  ]

  constructor(private http: HttpClient) { }

  getDocuments() {
    return of(this.documents);
    return this.http.get(urls.API_URL + urls.DOCUMENTS)
      .pipe(catchError(errorHandl));
  }

  getDocumentById(id: any) {
    return of(this.documents.find(document => document._id === id));
    // return this.http.get(urls.API_URL + urls.DOCUMENTS + `/${id}`)
    //   .pipe(catchError(errorHandl));
  }

  saveDocument(id: any, payload: any) {
    if (id) {
      return this.http.put(urls.API_URL + urls.DOCUMENTS + `/${id}`, payload)
      .pipe(catchError(errorHandl));
    } else {
      return this.http.post(urls.API_URL + urls.DOCUMENTS, payload)
      .pipe(catchError(errorHandl));
    }
  }

  getSpacetypes(queryParams?:any) {
    const params = new HttpParams({fromObject: queryParams});
    return this.http.get(urls.API_URL + urls.SPACETYPES, {params})
      .pipe(catchError(errorHandl));
  }

  getSpacetypeById(id: any) {
    return this.http.get(urls.API_URL + urls.SPACETYPES + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  saveSpacetype(id: any, payload: any) {
    if (id) {
      return this.http.patch(urls.API_URL + urls.SPACETYPES + `/${id}`, payload)
      .pipe(catchError(errorHandl));
    } else {
      return this.http.post(urls.API_URL + urls.SPACETYPES, payload)
      .pipe(catchError(errorHandl));
    }
  }

  saveLos(id:any,payload:any){
    if(id){
      return this.http.patch(urls.API_URL + urls.LEVELOFSERVICE +'/'+  id, payload)
      .pipe(catchError(errorHandl));
    }else{
      return this.http.post(urls.API_URL + urls.LEVELOFSERVICE, payload)
      .pipe(catchError(errorHandl));
    }
  }

  getLos(queryParams?:any){
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.LEVELOFSERVICE, {params})
    .pipe(catchError(errorHandl));
  }

  getLosById(id:any) {
    return this.http.get(urls.API_URL + urls.LEVELOFSERVICE +'/'+ id)
    .pipe(catchError(errorHandl));                     
  }
}

